/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_11_TitleInputs */

const en_terms_section_11_title = /** @type {(inputs: Terms_Section_11_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Changes to Terms`)
};

const lv_terms_section_11_title = /** @type {(inputs: Terms_Section_11_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Noteikumu izmaiņas`)
};

/**
* | output |
* | --- |
* | "11. Changes to Terms" |
*
* @param {Terms_Section_11_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_11_title = /** @type {((inputs?: Terms_Section_11_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_11_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_11_title(inputs)
	return en_terms_section_11_title(inputs)
});